import { AfterViewInit, Component } from '@angular/core';
import { PageLayoutComponent } from '@app/components/shared/page-layout/page-layout.component';
import { take } from 'rxjs';
import { SelectRaceComponent } from '@app/components/select-race/select-race.component';
import { delay, filter } from 'rxjs/operators';
import { defined } from '@app/fremework/functions';
import { MenuService } from '@app/components/shared/page-layout/menu.service';

@Component({
  selector: 'faxe-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports: [
    PageLayoutComponent,
    SelectRaceComponent
  ]
})
export class LandingComponent implements AfterViewInit{
  toggleMenu = undefined;

  constructor(
    private menuService: MenuService) {
  }

  ngAfterViewInit(): void {
    if(!this.menuService.once){
      this.menuService
        .toggleOpen$()
        .pipe(filter(_ => defined(_)), take(1), delay(500))
        .subscribe((value) => {
          this.toggleMenu = value;
        });
    }

  }

}
